import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CtaBand({ title = 'Get a free estimate in minutes', subtitle = 'Same-week availability across 5 South Florida counties — fully insured.' }) {
  return (
    <section className="relative my-12 md:my-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="relative overflow-hidden rounded-3xl border border-[#EED7A6] bg-cta-band p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <div>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#C8922F] font-semibold">
                <span className="h-1.5 w-1.5 rounded-full bg-[#C8922F]" /> South Florida's Trusted Service
              </div>
              <h2 className="mt-2 font-headline text-3xl md:text-4xl text-[#17352D] leading-tight">{title}</h2>
              <p className="mt-3 text-slate-700 max-w-md">{subtitle}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
              <Button asChild data-testid="cta-band-primary-button" className="rounded-xl bg-[#17352D] hover:bg-[#1E4338] text-white h-12 px-6">
                <Link to="/estimate"><Sparkles className="h-4 w-4 mr-2" /> Get Free Estimate</Link>
              </Button>
              <Button asChild data-testid="cta-band-call-button" variant="outline" className="rounded-xl border-[#17352D] text-[#17352D] hover:bg-[#F2F7F5] h-12 px-6">
                <a href="tel:5618848900"><Phone className="h-4 w-4 mr-2" /> 561-884-8900</a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
